/* CONTROL DE ORDENACIÓN DE TABLAS */

$(function () {
    $('body')
        .on('click', '.table thead>tr.tableHeaderOrdering>th[aria-order]', function (event) {
            let $target = $(event.target);
            if (!$target.is('input') && !$target.is('select')) {
                //Cambiamos el valor de la variable de orden correspondiente
                window['orderBy'] = [$(this).attr('aria-order')];
                //Cambiamos el icono de la cabecera del campo en la tabla correspondiente
                if ($(this).hasClass('sorting-ascendent')) {
                    $('.table thead>tr.tableHeaderOrdering>th[aria-order]').removeClass('sorting-ascendent sorting-descedent');
                    $(this).addClass('sorting-descedent');
                    window['orderDir'] = ['desc'];
                } else if ($(this).hasClass('sorting-descedent')) {
                    $('.table thead>tr.tableHeaderOrdering>th[aria-order]').removeClass('sorting-ascendent sorting-descedent');
                    $(this).addClass('sorting-ascendent');
                    window['orderDir'] = ['asc'];
                } else {
                    $('.table thead>tr.tableHeaderOrdering>th[aria-order]').removeClass('sorting-ascendent sorting-descedent');
                    $(this).addClass('sorting-descedent');
                    window['orderDir'] = ['desc'];
                }
                deleteCurrentParam('orderBy', null);
                setCurrentParam('orderBy', orderBy, false);
                deleteCurrentParam('orderDir', null);
                setCurrentParam('orderDir', orderDir, false);
                //$('body').trigger('changeOrderTableResult'); //Lanzamos un evento para ejecutar acciones custom.
                loadPage(1, window['callbackFunction'], window['selectorId']);
            }
        });
});

/* CONTROL DE ORDENACIÓN DE LISTAS */

/**
 * Change the order to show the elements list
 *
 * @param   {string}    orderBy       The order column to sort
 * @param   {string}    orderDir      The order direction to sort
 * @param   {function}  callback      The function to call for load new page
 * @param   {string}    selectorId    The selector to slide
 * @param   {object}    object        The selector element object
 */
window.changeOrder = function (
    orderBy,
    orderDir,
    callback   = function () {
    },
    selectorId = '',
    obj
) {
    $(obj).closest('.btn-group').find('.dropdown-toggle span').text($(obj).text())
    window.orderBy  = [orderBy];
    window.orderDir = [orderDir];
    setCurrentParam('orderBy', orderBy);
    setCurrentParam('orderDir', orderDir);
    // Recargamos el listado
    loadPage(currentPage, callback, selectorId);
};
